<oph-page-header
  [title]="'Lenses'"
  [description]="'Manage your lenses'"
  [primaryActionButtonText]="'Add Lens'"
  [primaryActionButtonIcon]="'plus-white'"
  (primaryActionButtonChange)="addLens()"
  (searchInputChange)="onSearchChange($event)"
/>
